<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="copy">
<p class="crtf">© 1999 by Sharon Linnéa Scott</p>
<p class="crt">Published 1999 by</p>
<p class="crt">Eerdmans Books for Young Readers</p>
<p class="crt">an imprint of</p>
<p class="crt">Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="crt">All rights reserved</p>
<p class="crt">February 2010, seventh printing</p>
<p class="cipf"><strong>Library of Congress Cataloging-in-Publication Data</strong></p>
<p class="cipf">Linnéa, Sharon.</p>
<p class="cip">Princess Ka‘iulani: hope of a nation, heart of a people / by Sharon Linnéa.</p>
<p class="cip">p. cm.</p>
<p class="cip">Includes <a href="#/eerkaiulani0039#bib">bibliographical references</a> and <a href="#/eerkaiulani0042#ind">index</a>.</p>
<p class="cip">ISBN 978-0-8028-5088-1 (pbk.: alk. paper); 978-1-4674-3200-9 (ePub)</p>
<p class="cip">1. Kaiulani, Princess of Hawaii, 1875–1899 — Juvenile literature.</p>
<p class="cip">2. Princesses — Biography — Juvenile literature.</p>
<p class="cip">3. Hawaii — History — Juvenile literature. I. Title.</p>
<p class="cip">DU627.17.K3L56 1999</p>
<p class="cip">996.9′ 02′ 092 — dc21</p>
<p class="cip">[B] 97-14260</p>
<p class="cip">CIP</p>
<p class="crtf"><a href="http://www.eerdmans.com/youngreaders" target="_blank">www.eerdmans.com/youngreaders</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0005.vue?c1362b6c